import * as React from "react"
import {
  Grid,
  makeStyles,
  Typography,
  useMediaQuery,
  useTheme,
  Button,
  Card,
  CardMedia,
  CardContent,
} from "@material-ui/core"
import Carousel from "react-slick"
import mobBG from "../../images/ebook-assets/mobBG.png"
import webBG from "../../images/ebook-assets/webBG.png"
import navRight from "../../images/banner-nav-right.svg"
import navLeft from "../../images/banner-nav-left.svg"
import classNames from "classnames"

const useStyles = makeStyles(theme => ({
  "@global": {
    body: {
      backgroundColor: "#EAEAEA",
    },
  },
  introHead: {
    backgroundImage: `url(${mobBG})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    marginTop: "1rem",
    [theme.breakpoints.up("md")]: {
      backgroundImage: `url(${webBG})`,
      alignItems: "flex-start",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      padding: "0 calc(100% - 97%)",
    },
    "& .MuiTypography-root": {
      color: "#ffffff",
      fontFamily: "'Poppins'",
    },
    "& .MuiTypography-h3": {
      fontWeight: "600",
      paddingTop: "2rem",
      [theme.breakpoints.up("md")]: {
        padding: "6rem 0rem 0rem 1rem",
        fontSize: "5rem",
      },
    },
    "& .MuiTypography-body2": {
      padding: "0.5rem calc(100% - 90%) 8rem calc(100% - 90%)",

      [theme.breakpoints.up("md")]: {
        padding: "0rem calc(100% - 55%) 8rem 1rem",
        fontSize: "1.1rem",
      },
    },
  },
  headContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      alignItems: "flex-start",
      padding: "calc(100% - 94%) calc(100% - 97%)",
    },
  },
  summarySection: {
    padding: "calc(100% - 90%)",
    [theme.breakpoints.up("md")]: {
      padding: "1rem 1rem 1rem 2rem",
    },
    "& .MuiTypography-h5": {
      fontFamily: "'Poppins'",
      fontWeight: 600,
      [theme.breakpoints.up("md")]: {
        fontSize: "1.5rem",
      },
    },
    "& .MuiTypography-subtitle2": {
      fontFamily: "'Poppins'",
      opacity: 0.8,
      padding: "12px 0px",
    },
    "& .MuiTypography-colorPrimary": {
      color: "#4499BA",
    },

    "& .MuiButton-root": {
      backgroundColor: "#1DAB45",
      color: "#ffffff",
      textTransform: "capitalize",
      width: "50%",
      borderRadius: "8px",
      marginTop: "24px",
      [theme.breakpoints.down(330)]: {
        width: "70%",
      },
      [theme.breakpoints.up("md")]: {
        alignSelf: "end",
      },
      "& .MuiButton-label": {
        fontFamily: "Poppins",
        fontSize: "1rem",
        fontWeight: 600,
      },
    },
  },
  mainVideo: {
    padding: "calc(100% - 90%)",
    marginTop: "-8rem",
    paddingBottom: 0,
    [theme.breakpoints.up("md")]: {
      padding: "1rem 2rem 1rem 1rem",
      marginTop: 0,
    },
  },
  videoContainer: {
    padding: "56.25% 0 0 0",
    position: "relative",
  },
  videoPlayer: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderRadius: "8px",
  },
  carouselContainer: {
    padding: "calc(100% - 90%)",
    [theme.breakpoints.down("sm")]: {
      paddingTop: 0,
    },
    [theme.breakpoints.up("md")]: {
      padding: "calc(100% - 97%)",
    },
    "& .MuiTypography-subtitle1": {
      fontFamily: "Poppins",
      fontWeight: 600,
      [theme.breakpoints.down("sm")]: {
        paddingBottom: "1rem",
      },
      [theme.breakpoints.up("md")]: {
        paddingLeft: "1rem",
      },
    },
  },
  salesCarousel: {
    paddingTop: 0,
  },
  videoSlider: {
    "& .slick-slide": {
      [theme.breakpoints.only("sm")]: {
        paddingRight: "1rem",
      },
      [theme.breakpoints.up("md")]: {
        padding: "1rem",
      },
    },
    "& .slick-current": {},
    "& .next, & .prev": {
      cursor: "pointer",
      zIndex: 1,
      width: "2.5rem",
    },
    "& .next": {
      position: "absolute",
      right: "-1.8rem",
      top: "40%",
      [theme.breakpoints.up("md")]: {
        right: "-1.5rem",
      },
    },
    "& .prev": {
      position: "absolute",
      left: "-1.8rem",
      top: "40%",
      [theme.breakpoints.up("md")]: {
        left: "-1.5rem",
      },
    },
    "& .MuiCardMedia-root": {
      border: "5px solid white",
    },
    "& .MuiCard-root": {
      borderRadius: "8px",
    },
  },
}))

const VideoCarousel = ({ videoFiles, title }) => {
  const classes = useStyles()

  const NextArrow = props => {
    const { onClick, style } = props
    style.display = onClick === null ? "none" : "block"
    return (
      <img
        src={navRight}
        className="next"
        onClick={onClick}
        style={style}
        alt="next"
      />
    )
  }

  const PrevArrow = props => {
    const { onClick, currentSlide } = props
    return (
      currentSlide !== 0 && (
        <img src={navLeft} className="prev" onClick={onClick} alt="prev" />
      )
    )
  }

  const sliderSettings = {
    slidesToShow: 3,
    speed: 500,
    infinite: false,
    slidesToScroll: 1,
    rows: 1,
    dots: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1050,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 1,
        },
      },
    ],
  }

  return (
    <Grid
      item
      xs={12}
      className={classNames(classes.carouselContainer, classes.salesCarousel)}
    >
      <Typography variant="subtitle1" gutterBottom>
        {title}
      </Typography>
      <Carousel {...sliderSettings} className={classes.videoSlider}>
        {videoFiles.map((vdo, idx) => (
          <Card key={idx}>
            <CardMedia>
              <div className={classes.videoContainer}>
                <iframe
                  src={vdo}
                  className={classes.videoPlayer}
                  frameborder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </CardMedia>
            <CardContent></CardContent>
          </Card>
        ))}
      </Carousel>
    </Grid>
  )
}
const VideoSection = () => {
  const classes = useStyles()
  const theme = useTheme()
  const upMD = useMediaQuery(theme.breakpoints.up("md"))

  return (
    <div>
      <Grid container direction="column" style={{ marginTop: '-22px' }}>
        <Grid item xs={12} className={classes.introHead}>
          <Typography variant="h3" align={upMD ? "left" : "center"}>
            Videos
          </Typography>
          <Typography variant="body2" align={upMD ? "left" : "center"}>
            Check out the Wersel Workdesk resource center to find videos that
            answer your questions about brand analytics, brand protection,
            counterfeit, ecommerce video analytics and more.
          </Typography>
        </Grid>
        <Grid item xs={12} container className={classes.headContainer}>
          <Grid item xs={upMD ? 6 : 12} className={classes.mainVideo}>
            <div className={classes.videoContainer}>
              <iframe
                src="https://player.vimeo.com/video/652798265?h=6b58335b49&title=0&byline=0&portrait=0"
                className={classes.videoPlayer}
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </Grid>
          <Grid item xs={upMD ? 6 : 12} className={classes.summarySection}>
            <Typography variant="h5" gutterBottom>
              Ecosystem for your business{" "}
            </Typography>
            <Typography variant="subtitle2">
              Wersel Workdesk is a unified data platform that encapsulates all
              the phases of data management and processing right from data
              ingestion of globally or publicly available data to visualizing
              the data, improving the enterprise search capabilities by bringing
              data from different places together, and finally how these data
              can efficiently collaborate across different stakeholders in
              real-time. In simple words Wersel Workdesk help brands to harvest,
              aggregate, analyze, and create actionable insights on large
              volumes of publicly available and Enterprise data.
            </Typography>
            <Button variant="contained" href="/">
              Find Out How
            </Button>
          </Grid>
        </Grid>
        <VideoCarousel
          videoFiles={marketingVideos}
          title="Marketing and Advertising Industry"
        />
        <VideoCarousel
          videoFiles={eCommerceVideos}
          title="Ecommerce Industry"
        />
      </Grid>
    </div>
  )
}

export default VideoSection

const marketingVideos = [
  "https://player.vimeo.com/video/615721647?h=6081e5a723&title=0&byline=0&portrait=0",
  "https://player.vimeo.com/video/593644229?h=94421882e1&title=0&byline=0&portrait=0",
  "https://player.vimeo.com/video/593643734?h=697f4d7063&title=0&byline=0&portrait=0",
  "https://player.vimeo.com/video/593643044?h=4decfa063f&title=0&byline=0&portrait=0",
  "https://player.vimeo.com/video/593642225?h=bf5a93dbaa&title=0&byline=0&portrait=0",
]
const eCommerceVideos = [
  "https://player.vimeo.com/video/592726110?h=5cc432f864&title=0&byline=0&portrait=0",
  "https://player.vimeo.com/video/613569378?h=84c6325dd6&title=0&byline=0&portrait=0",
  "https://player.vimeo.com/video/613563739?h=fa052cd1b9&title=0&byline=0&portrait=0",
  "https://player.vimeo.com/video/612535708?h=4dcd20afca&title=0&byline=0&portrait=0",
  "https://player.vimeo.com/video/612342487?h=ae84f12719&title=0&byline=0&portrait=0",
  "https://player.vimeo.com/video/593641399?h=deddea5ddb&title=0&byline=0&portrait=0",
  "https://player.vimeo.com/video/593641673?h=b3d9fa2e7f&title=0&byline=0&portrait=0",
]
